<a [href]="href" class="alert-link" [class]="size">
  <ng-content></ng-content>
</a>
